export default __webpack_public_path__ + "static/media/KebabMenu.9f0fe4fc.svg";